import { useEffect, useState } from "react";
import { Box } from "@material-ui/core";

import { getData } from "../../../../../services";
import { ConnectionStatus, NoDataCard } from "../../../../../components/parts";
import { CONNECTION_STATUS_LEGEND_COLORS, CONNECTION_STATUS_PIE_DATA } from "../../../constants";

const defaultConnectionStatus = {
  meter_type: null,
  chart_data: [],
};

export const ConnectionStatusComponent = ({ id }) => {
  const [connectionStatus, setConnectionStatus] = useState(defaultConnectionStatus);

  useEffect(() => {
    getData(`/praas/v2/buildings/${id}/properties/connection-status/`, (data) => {
      const tempChartData = [...CONNECTION_STATUS_PIE_DATA];
      tempChartData.forEach((pieData) => {
        const value = data[pieData.name];
        pieData.value = value;
        pieData.legendValue = value;
      });
      setConnectionStatus({
        meter_type: data.meter_type,
        since_connected: data?.since_connected,
        status: data?.status,
        chart_data: tempChartData,
        total: data?.total,
      });
    });
  }, [id]);

  return (
    <Box height="100%">
      {connectionStatus.meter_type && connectionStatus?.total > 0 ? (
        <ConnectionStatus
          chartData={connectionStatus.chart_data}
          legendColors={CONNECTION_STATUS_LEGEND_COLORS}
          meterType={connectionStatus.meter_type}
          status={connectionStatus.status}
          sinceConnected={connectionStatus.since_connected}
        />
      ) : (
        <NoDataCard title="Meters PRaaS-Connection Status" />
      )}
    </Box>
  );
};
